import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  andAllWhere,
  andWhere,
  buildQuery,
  noop,
  Ops,
  orderBy,
  OrderVariant,
  orWhere,
  page,
  select,
  where,

} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { HttpClient } from "@angular/common/http";
import {
  IPagination,
  IPaginationResult,
  IRequestResult,
} from "../../../../common/interfaces";
import { ICreatePhoneType } from "./interfaces/create-phone-type.interface";
import { IUpdatePhoneType } from "./interfaces/update-phone-type.interface";
import { environment as env } from "../../../../../environments/environment.prod";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import { AbstractService } from "../../../../services/abstract.service";
import PhoneTypeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/common/masters/phone-type/phone-type.entity";

const apiUrl = env.API_COMMON_URL;
const moduleName = "phone_type";

@Injectable({
  providedIn: "root",
})
export class PhoneTypeService extends AbstractService<
  PhoneTypeAttributes,
  ICreatePhoneType,
  IUpdatePhoneType
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findAllWithCount(
    options: IPagination<PhoneTypeAttributes> & { status?: number[] }
  ): Observable<IPaginationResult<PhoneTypeAttributes>> {
    let query = buildQuery<PhoneTypeAttributes>(
      where('_deleted', Ops.eq(false)),
      andWhere("type", Ops.like(options.search ?? "", "i")),
      options.status && options.status.length > 0 ? andAllWhere('statusId', Ops.in(...options.status)) : andAllWhere('statusId', Ops.in(...[])),
      orderBy(
        options.sort ?? "type",
        options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
      ),
      page(options.currentPage ?? 1, options.limitPerPage ?? 100)
    );


    const API_URL: string =
      apiUrl +
      `api/${moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IPaginationResult<PhoneTypeAttributes>>(API_URL);
  }

  /**
   * Find to combo box
   * @returns Data
   */
  findToComboBox(): Observable<IRequestResult<PhoneTypeAttributes[]>> {
    const query = buildQuery<PhoneTypeAttributes>(
      where("statusId", StatusEnum.ACTIVE),
      select(["type"]),
      // orderBy("code", OrderVariant.Asc)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/filter?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IRequestResult<PhoneTypeAttributes[]>>(API_URL);
  }
}
